<skeleton-legal-document *ngIf="loading; else loadedContent"></skeleton-legal-document>
<ng-template #loadedContent>
  <div class="legal-documents" [innerHTML]="termsHtml"></div>
</ng-template>
